// extracted by mini-css-extract-plugin
export default {"loader":"base-nav-option-module__loader--YKsQO"};